export const defaultColumns = [
  { value: 'protocol_number', label: 'Transação' },
  { value: 'eventable_type', label: 'Tipo' },
  { value: 'details', label: 'Detalhes' },
  { value: 'license_plate', label: 'Placa do Veículo' },
  { value: 'total_amount', label: 'Vlr. Total' },
  { value: 'client_company', label: 'Filial' },
  { value: 'card', label: 'Cartão' },
  { value: 'usage_declaration', label: 'Uso Declarado' },
  { value: 'capture_method', label: 'Método de captura' },
  { value: 'buyer', label: 'Responsável' },
  { value: 'created_at', label: 'Data e Hora' },
  { value: 'actions', label: 'Ações' },
]
